import PropTypes from "prop-types";
import { forwardRef } from "react";
import { Icon } from "@iconify/react";
import { Box } from "@material-ui/core";

const Iconify = forwardRef(
  ({ icon, width = 20, height, sx, ...other }, ref) => (
    <Box
      ref={ref}
      sx={{
        width,
        height: height ?? width,
        display: "inline-flex",
        flexShrink: 0,
        ...sx,
      }}
    >
      <Icon icon={icon} width={width} height={height ?? width} {...other} />
    </Box>
  ),
);

Iconify.propTypes = {
  sx: PropTypes.object,
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  icon: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
    PropTypes.object,
  ]),
};

export default Iconify;
